export default from './AffiliateMappings';



// WEBPACK FOOTER //
// ./src/containers/AffiliateMappings/index.js